import ResourceTable from './ResourceTable';

export default ResourceTable;